import { cn } from "../../lib/cn"

export function Card({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("rounded-xl border border-border-subtle bg-surface", className)}
      {...props}
    />
  )
}
